













import { ErrorBox, FieldErrorsView} from '@simonbackx/simple-error-forms';
import { Component, Prop,Vue } from "vue-property-decorator";

@Component({
    components: {
        FieldErrorsView
    }
})
export default class InputBox extends Vue {
    @Prop({ default: ""}) errorFields: string;
    @Prop({ default: null }) errorBox: ErrorBox | null;

    @Prop({ default: ""})
    title!: string
}
